/**
 * Given a user's ID, return the full URL of their avatar. Since avatars are
 * placed at canonical URLs, this is statically known without any more data.
 */
const getUserAvatarUrl = (userId: string) => `user-avatar/${userId}`;

export default getUserAvatarUrl;
